import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import vuetify from './plugins/vuetify';

import '@/assets/styles.css';
import '@/components_import.js';
import '@/filters.js';
import endpoints from '@/api/endpoints.js';
import icons from '@/icons.js';

Vue.prototype.$axios = axios;
Vue.prototype.$endpoints = endpoints;
Vue.prototype.$icons = icons;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');